import React from "react";
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import type { EntityStatus } from "../../types";

interface DevopsEntityCardProps {
  title: string;
  subtitle?: string;
  status: EntityStatus | string;
  metadata?: React.ReactNode;
  onAskAgent: () => void;
  onView: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  extraActions?: React.ReactNode;
}

const DevopsEntityCard: React.FC<DevopsEntityCardProps> = ({
  title,
  subtitle,
  status,
  metadata,
  onAskAgent,
  onView,
  onEdit,
  onDelete,
  extraActions,
}) => (
  <Card variant="outlined" sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
    <CardContent sx={{ flex: 1, cursor: "pointer" }} onClick={onView}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
        <Chip size="small" label={status} />
      </Stack>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
      {metadata && <Box sx={{ mt: 1 }}>{metadata}</Box>}
    </CardContent>
    <Box sx={{ px: 2, pb: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
      <Button size="small" variant="outlined" onClick={onView}>
        View
      </Button>
      <Button
        size="small"
        variant="outlined"
        onClick={(event) => {
          event.stopPropagation();
          onAskAgent();
        }}
      >
        Ask agent
      </Button>
      {onEdit && (
        <Button size="small" onClick={onEdit}>
          Edit
        </Button>
      )}
      {onDelete && (
        <Button size="small" color="error" onClick={onDelete}>
          Delete
        </Button>
      )}
      {extraActions}
    </Box>
  </Card>
);

export default DevopsEntityCard;
